<div class="container-beta-warning">
  <div class="container-content">
    <h1>{{ 'CONNECTION.BETAVERSION' | translate }}</h1>
    <p>{{ 'CONNECTION.BETAWARNING' | translate }}</p>

    <div class="container-footer">
      <button matButton="filled" (click)="backToProd()">
        {{ 'CONNECTION.BACKSAFE' | translate }}
      </button>
      <button matButton="outlined" (click)="agree()" (keyup.enter)="agree()">
        {{ 'CONNECTION.AGREEBETA' | translate }}
      </button>
    </div>
  </div>
</div>
